import { ShopState, Shop } from "../../types";
import type { Action } from "../store";

const initialState: ShopState = [];

export const setShops = (payload: Shop[]) => ({
  type: "shops/setShops" as const,
  payload,
});

export default function shopReducer(state: ShopState = initialState, action: Action): ShopState {
  return action.type === "shops/setShops" ? (action.payload as Shop[]) : state;
}
